import { getApiErrorMessage } from "helpers/embedded"
import { CART_HOLD_STATUSES } from "../constants"
import { getBookableTicketTypes } from "../helpers"
import { getAvailabilityError } from "../WidgetCheckout/payment"

// An API refusal for availability (its error `message`), worded as the panel's "Availability has
// changed: ..." messages: a start time that's gone, or fewer places of a ticket type. Null for any
// other refusal.
export const describeAvailabilityRefusal = ({ message, experience, t }) => {
  const unavailable = getAvailabilityError({ data: { message } })
  if (unavailable?.kind === "tickets") {
    const ticketType = getBookableTicketTypes(experience).find((type) => String(type.id) === String(unavailable.ticketTypeId))
    if (ticketType) return t("booking_widget.experience.availability.type_places_now", { count: unavailable.remaining, title: ticketType.title })
  }
  if (unavailable) return t("booking_widget.experience.availability.slot_unavailable")
  return null
}

// Why a cart item's places are no longer held (the API's reason for a lost item): an availability
// refusal as above, else the API's own text. Null while the item is held.
export const getHoldIssue = ({ item, experience, t }) => {
  if (item?.holdStatus !== CART_HOLD_STATUSES.lost) return null
  return (
    describeAvailabilityRefusal({ message: item.holdError, experience, t }) ||
    getApiErrorMessage({ data: { message: item.holdError } }) ||
    t("booking_widget.experience.availability.slot_unavailable")
  )
}
